import React , {Fragment} from "react";
import {
    Snackbar
  } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
 

const withAlert = (Component) => {

    const WithAlertComponent = (props) => {

    const [openSnack, setOpenSnack] = React.useState(false);
    const [snackType, setSnackType] = React.useState('success');
    const [snackMessage, setSnackMessage] = React.useState('');
  
    const handleCloseSnack = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpenSnack(false);
    };
  
  
    return (
        <Fragment>
        <Snackbar open={openSnack} autoHideDuration={3000} onClose={handleCloseSnack}>
        <Alert onClose={handleCloseSnack} severity={snackType}>
          {snackMessage}
        </Alert>
        </Snackbar>

        <Component {...props} setSnackMessage={setSnackMessage} setSnackType={setSnackType} setOpenSnack={setOpenSnack}/>
      </Fragment>
    )
    };
    return WithAlertComponent;
  };
  

export default withAlert;
